import { Table, InputNumber, Icon, Modal, Button } from "antd";
import React, { useEffect, useState } from "react";
import style from "./index.module.scss";
import { ModalProps } from "antd/es/modal";
import {
    AllConfig,
    detailWeight,
    queryForGradeRule,
    queryGradeRuleItem
} from "service/score";
import useRequest from "utils/useRequest";
import { useParams } from "react-router-dom";
import { ColumnProps } from "antd/lib/table/interface";
import _ from "underscore";
import moment from "moment/moment";
import lodash from "lodash-es";
import { toNumber } from "../../../../../../../../../service/service";

interface DetailSettingModalProps extends ModalProps {
    detailTitle: string; //弹窗名称
    onCancel: () => void;
    obj: AllConfig; //细则对象值
    setObj: (val: AllConfig) => void; //回显
    onSave: (val: AllConfig) => void; //保存
    type?: string; //当前项类型
}

const Index = ({
    detailTitle,
    onCancel,
    onSave,
    obj,
    setObj,
    type,
    ...props
}: DetailSettingModalProps) => {
    const { courseNo, courseSeq } = useParams<StringMap>();

    const [data, { loading }] = useRequest(
        async () => {
            if (!!type) {
                return queryForGradeRule(detailWeight[type], {
                    courseNo,
                    courseSeq
                });
            } else {
                return [];
            }
        },
        {},
        [type, courseNo, courseSeq]
    );

    const [dataSource, setDataSource] = useState(data);

    useEffect(() => {
        if (obj?.detailWeight && obj.detailWeight.length !== 0) {
            if (data) {
                const ids = _.pluck(data, "id");
                const newDetailWeight = obj.detailWeight.filter(item =>
                    ids.includes(item.id)
                );
                const newIds = _.pluck(newDetailWeight, "id");
                const newData = data.filter(
                    (item: queryGradeRuleItem) => !newIds.includes(item.id)
                );
                setDataSource([...newData, ...newDetailWeight]);
                return;
            }
            setDataSource(obj.detailWeight);
        } else {
            setDataSource(data);
        }
    }, [data, obj?.detailWeight]);

    const onOk = async () => {
        await setObj({ ...obj, detailWeight: dataSource });
        await onSave({ ...obj, detailWeight: dataSource });
        onCancel();
    };

    const columns: ColumnProps<queryGradeRuleItem>[] = [
        {
            title: <div>{detailTitle}名称</div>,
            dataIndex: "name",
            key: "name",
            ellipsis: true,
            width: 200
        },
        {
            title: "创建时间",
            dataIndex: "createTime",
            key: "createTime",
            ellipsis: true,
            width: 180,
            render: (text: string) =>
                text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : "",
            sorter: (a, b) => moment(a.createTime).diff(b.createTime),
            sortDirections: ["ascend", "descend"]
        },
        {
            title: "权重",
            dataIndex: "weight",
            key: "weight",
            align: "center",
            render: (
                value: number,
                record: queryGradeRuleItem,
                index: number
            ) => {
                return (
                    <InputNumber
                        min={0}
                        max={100}
                        defaultValue={value}
                        precision={1}
                        className={style.inputNumber}
                        onChange={newValue => {
                            // 更新数据源中的权重值
                            const newDataSource = lodash.cloneDeep(dataSource);
                            newDataSource[index].weight = newValue;
                            setDataSource(newDataSource);
                        }}
                    />
                );
            }
        }
    ];

    // 总分
    const totalCount = _.reduce(
        dataSource,
        (num, memo) => num + toNumber(memo.weight),
        0
    ).toFixed(1);

    const footer = (
        <div>
            <Button key="back" onClick={onCancel}>
                取消
            </Button>
            <Button
                key="submit"
                onClick={onOk}
                type="primary"
                disabled={
                    Number(totalCount) !== 100 && Number(totalCount) !== 0
                }>
                确认
            </Button>
        </div>
    );

    return (
        <Modal
            title={detailTitle + "明细分配"}
            width={610}
            className={style.root}
            closable={false}
            centered
            footer={footer}
            {...props}>
            <div className={style.tips}>
                说明：默认无权重分配按全部{detailTitle}
                折算成百分制后取平均成绩，如设置权重，则按分配的权重计算得分。
            </div>

            <div className={style.description}>
                <Icon type="exclamation-circle" />
                若分配权重，总权重需满足100%，否则无法保存，当前合计
                <strong
                    className={
                        Number(totalCount) === 100 ? style.success : style.error
                    }>
                    {totalCount}
                </strong>
            </div>
            <Table
                dataSource={dataSource}
                columns={columns}
                rowKey={"id"}
                pagination={false}
                loading={loading}
                scroll={{ y: 265 }}
            />
        </Modal>
    );
};

export default Index;
